import React, { useState, useRef } from 'react';
import { DownloadIcon, ChevronDownIcon, FileTextIcon, FileSpreadsheetIcon, FileIcon } from 'lucide-react';
interface ExportMenuProps {
  onExport: (format: 'csv' | 'xlsx' | 'pdf') => void;
  className?: string;
}
const ExportMenu: React.FC<ExportMenuProps> = ({
  onExport,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleExport = (format: 'csv' | 'xlsx' | 'pdf') => {
    onExport(format);
    setIsOpen(false);
  };
  return <div className={`relative ${className}`} ref={menuRef} data-id="element-237">
      <button onClick={toggleMenu} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-238">
        <DownloadIcon className="h-4 w-4 mr-2" data-id="element-239" />
        Export
        <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-240" />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-10" data-id="element-241">
          <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-242">
            <button onClick={() => handleExport('csv')} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700" role="menuitem" data-id="element-243">
              <FileTextIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-244" />
              Export as CSV
            </button>
            <button onClick={() => handleExport('xlsx')} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700" role="menuitem" data-id="element-245">
              <FileSpreadsheetIcon className="h-4 w-4 mr-2 text-green-500 dark:text-green-400" data-id="element-246" />
              Export as Excel
            </button>
            <button onClick={() => handleExport('pdf')} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700" role="menuitem" data-id="element-247">
              <FileIcon className="h-4 w-4 mr-2 text-red-500 dark:text-red-400" data-id="element-248" />
              Export as PDF
            </button>
          </div>
        </div>}
    </div>;
};
export default ExportMenu;